// extracted by mini-css-extract-plugin
export default {"lipaworld_navButton":"CartIcon_lipaworld_navButton__5To4N","lipaworld_navIcon":"CartIcon_lipaworld_navIcon__THEX0","lipaworld_quantity":"CartIcon_lipaworld_quantity__GwljU"};